import { render, staticRenderFns } from "./radio-modal-option-conf.mpx?vue&type=template&id=6b30ddb6&isComponent&outputPath=components%2Fradio-modal-option-conf6886577e%2Findex"
import script from "./radio-modal-option-conf.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-modal-option-conf6886577e%2Findex"
export * from "./radio-modal-option-conf.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio-modal-option-conf6886577e%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports